import JobChecklistsPage from '@/pages/jobs/checklists'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventChecklistsPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobChecklistsPage />
    </WorkspacePortalProvider>
  )
}
